var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from '../framework/AsciiText';
export class I3TouchXOne {
    constructor(socket, log) {
        this.socket = socket;
        // The emulator stores the 'set' video code as the source and translates the video input to the
        // 'getValue' when queried.
        this.videoInputMaps = {
            '-NLaeW7DjRpc09dWO4Py': {
                // I3Touch X-One
                0x1c: { name: 'android', getValue: 0x30 },
                0x38: { name: 'ops pc', getValue: 0x17 },
                0x52: { name: 'hdmi 1', getValue: 0x1f },
                0x53: { name: 'hdmi 2', getValue: 0x1e },
                0x54: { name: 'usb-c front', getValue: 0x00 },
                0x55: { name: 'usb-c rear', getValue: 0x01 },
                0x56: { name: 'displayPort', getValue: 0x20 },
            },
            '-NPP3sSWhSGTS5yu89oL': {
                // NewLine NT/NT+
                0x16: { name: 'ops pc', getValue: 0x38 },
                0x52: { name: 'hdmi 1', getValue: 0x1f },
                0x53: { name: 'hdmi 2', getValue: 0x1e },
                0x54: { name: 'hdmi 3', getValue: 0x18 },
                0x55: { name: 'hdmi 4', getValue: 0x17 },
            },
            '-NmGtbdWriaFoqkhuyaM': {
                // I3Touch Sixty 2
                0x1c: { name: 'android', getValue: 0x30 },
                0x38: { name: 'ops pc', getValue: 0x17 },
                0x52: { name: 'hdmi 1', getValue: 0x1f },
                0x53: { name: 'hdmi 2', getValue: 0x1e },
                0x54: { name: 'usb-c front', getValue: 0x00 },
                0x55: { name: 'usb-c rear', getValue: 0x01 },
                0x56: { name: 'displayPort', getValue: 0x20 },
            },
            '-ORBo4vL4Na35PlIerRC': {
                // Newline Q Pro
                0x56: { name: 'dp', getValue: 0x20 },
                0x54: { name: 'vga/usb-c front', getValue: 0x00 },
                0x55: { name: 'usb-c rear', getValue: 0x01 },
                0x38: { name: 'pc', getValue: 0x17 },
                0x53: { name: 'hdmi 3', getValue: 0x1e },
                0x52: { name: 'hdmi 2', getValue: 0x1f },
                0x0a: { name: 'hdmi 1', getValue: 0x19 },
            },
        };
        this.videoInputMap = this.videoInputMaps['-NLaeW7DjRpc09dWO4Py'];
        this.displayFreeze = false;
        this.power = false;
        this.videoInput = 0x52; // hdmi1
        this.volume = 50;
        this.asyncHandlers = [
            {
                name: 'displayFreezeSet',
                regExp: /\x7f[\s\S]\x99\xa2\xb3\xc4\x02\xff\x0b([\s\S])\xcf/,
                callback: (match) => {
                    // Set 0 => display freeze true
                    this.displayFreeze = match[1].charCodeAt(0) === 0;
                    this.socket.send(this.makeCommand([0x0b, this.displayFreeze ? 0x00 : 0x01, 0x01]));
                },
            },
            {
                name: 'directionNavigation',
                regExp: /\x7f[\s\S]\x99\xa2\xb3\xc4\x02\xff\x01([\x1d\x2b\x2c\x2d\x2e\x2f])\xcf/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x01, match[1].charCodeAt(0), 0x01]));
                },
            },
            {
                name: 'powerGet',
                regExp: /\x7f[\s\S]\x99\xa2\xb3\xc4\x02\xff\x01\x37\xcf/,
                callback: (match) => {
                    // Get 0 => power off, 1 => power on
                    this.socket.send(this.makeCommand([0x01, 0x37, this.power ? 0x01 : 0x00]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\x7f[\s\S]\x99\xa2\xb3\xc4\x02\xff\x01([\x00\x01])\xcf/,
                callback: (match) => {
                    // Set 0 => power on, 1 => power off
                    this.power = match[1].charCodeAt(0) === 0;
                    this.socket.send(this.makeCommand([0x01, this.power ? 0x00 : 0x01, 0x01]));
                },
            },
            {
                name: 'videoInputGet',
                regExp: /\x7f\x08\x99\xa2\xb3\xc4\x02\xff\x01\x50\xcf/,
                callback: (match) => {
                    var _a;
                    const getValue = (_a = this.videoInputMap[this.videoInput]) === null || _a === void 0 ? void 0 : _a.getValue;
                    if (getValue !== undefined) {
                        this.socket.send(this.makeCommand([0x01, 0x50, getValue]));
                    }
                },
            },
            {
                name: 'videoInputSet',
                regExp: /\x7f\x08\x99\xa2\xb3\xc4\x02\xff\x01([\s\S])\xcf/,
                callback: (match) => {
                    this.videoInput = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0x01, this.videoInput, 0x01]));
                },
            },
            {
                name: 'volumeGet',
                regExp: /\x7f\x08\x99\xa2\xb3\xc4\x02\xff\x01\x33\xcf/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x01, 0x33, this.volume]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x7f\x08\x99\xa2\xb3\xc4\x02\xff\x05([\s\S])\xcf/,
                callback: (match) => {
                    this.volume = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0x05, this.volume, 0x01]));
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    makeCommand(data) {
        const bytes = [
            0x7f,
            0x06 + data.length,
            0x99,
            0xa2,
            0xb3,
            0xc4,
            0x02,
            0xff,
            ...data,
            0xcf,
        ];
        return AsciiText.decode(bytes);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 6688 || this.power);
        });
    }
    onConfigure(config) {
        var _a, _b, _c, _d;
        const modelNumber = (_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : '-NLaeW7DjRpc09dWO4Py';
        this.videoInputMap =
            (_b = this.videoInputMaps[modelNumber]) !== null && _b !== void 0 ? _b : this.videoInputMaps['-NLaeW7DjRpc09dWO4Py'];
        let lowestCode;
        for (const videoInput of Object.values((_c = config.videoInputs) !== null && _c !== void 0 ? _c : {})) {
            const code = (_d = videoInput === null || videoInput === void 0 ? void 0 : videoInput.code.charCodeAt(0)) !== null && _d !== void 0 ? _d : 0x00;
            if (this.videoInput === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.videoInput = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0x53;
    }
    commandExtractor(buffer) {
        // Command Format:
        //   0x7F [length] 0x99 0xA2 0xB3 0xC4 0x02 0xFF 0x01 [data] 0xCF
        //
        // Try each byte as a starting position in case we receive any corrupted data.
        for (let i = 0; i < buffer.length - 1; i++) {
            // Commands start with 0x7f and end with 0xcf.
            if (buffer.charCodeAt(i) !== 0x7f)
                continue;
            const cmdLength = buffer.charCodeAt(i + 1);
            if (i + cmdLength + 3 <= buffer.length && buffer.charCodeAt(cmdLength + 2) === 0xcf) {
                const command = buffer.slice(i, i + cmdLength + 3);
                buffer = buffer.slice(i + cmdLength + 3);
                return { command, buffer };
            }
        }
        return undefined;
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 6688 || this.power);
    }
}
I3TouchXOne.emulatorType = 'socketEmulator';
I3TouchXOne.key = '-NMAojcsneFqYF6MUdAE';
